import Lenis from 'lenis';

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { SplitText } from "gsap/SplitText"; /* This plugin is a Club GSAP perk */
gsap.registerPlugin(ScrollTrigger, SplitText, MotionPathPlugin);

document.addEventListener('DOMContentLoaded', function () {
    // Stockage des instances SplitText
    let splitTextInstances = [];

    // Fonction pour gérer le debounce du resize
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Nouvelle fonction pour gérer le SplitText du screen4
    function handleScreen4Text() {
        const text4 = document.querySelector('#screen4 [data-anim="text"]');
        if (!text4) return;

        // Si un SplitText existe déjà sur cet élément, on le revert
        if (text4._split) {
            text4._split.revert();
        }

        // Création du nouveau SplitText
        const splitText4 = new SplitText(text4, {
            type: "lines",
            linesClass: "split-line"
        });

        // Stockage de la référence pour le revert futur
        text4._split = splitText4;

        // Configuration initiale
        gsap.set(splitText4.lines, {
            opacity: 0,
            y: 40
        });

        return splitText4;
    }

    // Nouvelle fonction pour gérer le SplitText du screen5
    function handleScreen5Text() {
        const text5 = document.querySelector('#screen5 [data-anim="text"]');
        if (!text5) return;

        // Si un SplitText existe déjà sur cet élément, on le revert
        if (text5._split) {
            text5._split.revert();
        }

        // Création du nouveau SplitText
        const splitText5 = new SplitText(text5, {
            type: "lines",
            linesClass: "split-line"
        });

        // Stockage de la référence pour le revert futur
        text5._split = splitText5;

        // Configuration initiale
        gsap.set(splitText5.lines, {
            opacity: 0,
            y: 40
        });

        return splitText5;
    }

    // Fonction pour initialiser toutes les animations
    function initAnimations() {
        // Kill tous les ScrollTriggers existants
        ScrollTrigger.getAll().forEach(st => st.kill());

        /** Animations -- SCREEN 1 **/
        // Nuage 1
        gsap.set('#screen1 [data-anim="cloud1"]', {
            xPercent: -80,
            y: 50,
        });
        gsap.to('#screen1 [data-anim="cloud1"]', {
            xPercent: -30,
            yPercent: 50,
            scrollTrigger: {
                trigger: '#screen1 [data-anim="cloud1"]',
                start: 'top bottom',
                end: 'bottom -20%',
                scrub: 1,
            },
        });

        // Nuage 2
        gsap.set('#screen1 [data-anim="cloud2"]', {
            xPercent: 80,
            y: 120,
        });
        gsap.to('#screen1 [data-anim="cloud2"]', {
            xPercent: 10,
            yPercent: 25,
            scrollTrigger: {
                trigger: '#screen1 [data-anim="cloud2"]',
                start: 'top bottom',
                end: 'bottom -20%',
                scrub: 1,
            },
        });

        // Paysage
        gsap.set('#screen1 [data-anim="landscape"]', {
            position: "relative",
            zIndex: 1,
        });
        gsap.to('#screen1 [data-anim="landscape"]', {
            marginTop: "0",
            scrollTrigger: {
                trigger: '#screen1',
                start: 'top top',
                end: 'bottom -20%',
                scrub: 1,
            },
        });

        /** Animations -- SCREEN 2 **/
        const screen2Timeline = gsap.timeline({
            scrollTrigger: {
                trigger: '#screen2',
                start: 'top top',
                end: '+=125%',
                pin: true,
                scrub: 1,
                pinSpacing: true
            }
        });

        // Face
        gsap.set('#screen2 [data-anim="face"]', {
            yPercent: 32,
        });
        screen2Timeline.to('#screen2 [data-anim="face"]', {
            duration: 1,
            yPercent: -5
        });

        /** Animations -- SCREEN 3 **/
        // Animation d'entrée de la map
        gsap.set('#screen3 [data-anim="map"]', {
            xPercent: 5,
            opacity: 0
        });

        gsap.to('#screen3 [data-anim="map"]', {
            xPercent: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: '#screen3',
                start: 'top 80%',
                end: 'top center',
                scrub: 1
            }
        });

        // Animation du path
        gsap.to('#screen3 .st0', {
            duration: 2.5,
            motionPath: {
                path: '#screen3 .st1',
                align: '#screen3 .st1',
                alignOrigin: [0.5, 0.5],
                autoRotate: true
            },
            scrollTrigger: {
                trigger: '#screen3',
                start: 'top 70%',
                end: 'bottom center',
                scrub: 1
            }
        });

        // Positions initiales des éléments
        gsap.set('#screen3 [data-anim="unicorn"]', {
            xPercent: -100,
            top: 300,
        });

        gsap.set('#screen3 [data-anim="devil"]', {
            xPercent: 100,
            top: -80,
        });

        gsap.set('#screen3 [data-anim="cloud"]', {
            xPercent: 60,
            right: -100,
        });

        // Animations des éléments décoratifs
        gsap.to('#screen3 [data-anim="unicorn"]', {
            xPercent: -40,
            yPercent: 30,
            scrollTrigger: {
                trigger: '#screen3',
                start: 'top 80%',
                end: 'bottom bottom',
                scrub: 1
            }
        });

        gsap.to('#screen3 [data-anim="devil"]', {
            xPercent: 0,
            yPercent: 60,
            scrollTrigger: {
                trigger: '#screen3',
                start: 'top 90%',
                end: 'bottom bottom',
                scrub: 1
            }
        });

        gsap.to('#screen3 [data-anim="cloud"]', {
            xPercent: 0,
            scrollTrigger: {
                trigger: '#screen3 [data-anim="cloud"]',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1
            }
        });

        // Giant
        gsap.set('#screen3 [data-anim="giant"]', {
            xPercent: -20
        });
        gsap.to('#screen3 [data-anim="giant"]', {
            xPercent: 150,
            scrollTrigger: {
                trigger: '#screen3 [data-anim="giant"]',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1
            }
        });

        /** Animations -- SCREEN 4 **/
        const feastTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '#screen4 [data-anim="feast-container"]',
                start: 'bottom bottom',
                end: '+=500%',
                pin: true,
                scrub: 1,
                pinSpacing: true
            }
        });

        // État initial
        gsap.set('#screen4 [data-anim="feast"]', {
            opacity: 0.2
        });

        // Récupération du SplitText
        const splitText4 = handleScreen4Text();

        // Animation séquentielle
        feastTimeline
            .to('#screen4 [data-anim="left"]', {
                xPercent: -100,
                duration: 1
            })
            .to('#screen4 [data-anim="right"]', {
                xPercent: 100,
                duration: 1
            }, "<")
            .to('#screen4 [data-anim="feast"]', {
                opacity: 1,
                duration: 1
            }, "<")
            .fromTo('#screen4 [data-anim="giant"]', {
                yPercent: 100,
            }, {
                yPercent: 0,
                duration: 1
            })
            .to(['#screen4 [data-anim="left"]', '#screen4 [data-anim="right"]', '#screen4 [data-anim="feast"]'], {
                opacity: 0,
                duration: 1
            }, "<")
            .to('#screen4 [data-anim="giant"]', {
                scale: 8,
                opacity: 0,
                duration: 2
            })
            .to(splitText4.lines, {
                opacity: 1,
                y: 0,
                duration: 1,
                stagger: 0.1
            }, "<+1");

        /** Animations -- SCREEN 5 **/
        // Configuration initiale
        gsap.set('#screen5 [data-anim="face"]', {
            yPercent: 50,
        });

        const faceTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '#screen5',
                start: 'top top',
                end: '+=200%',
                pin: true,
                scrub: 1,
                pinSpacing: true,
            }
        });

        // Récupération du SplitText
        const splitText5 = handleScreen5Text();

        faceTimeline
            .to('#screen5 [data-anim="vines"]', {
                yPercent: -100,
                duration: 1.6
            })
            .to('#screen5 [data-anim="face"]', {
                yPercent: 0,
                duration: 1
            }, "<")
            .to('#screen5 [data-anim="face"]', {
                xPercent: -27,
                scale: 1.1,
                duration: 3
            })
            .to(splitText5.lines, {
                opacity: 1,
                y: 0,
                duration: 1,
                stagger: 0.1
            }, "<+=1");

        /** Animations -- SCREEN 6 **/
        // Cloud
        gsap.set('#screen6 [data-anim="cloud"]', {
            xPercent: 50,
        });

        gsap.to('#screen6 [data-anim="cloud"]', {
            xPercent: 0,
            scrollTrigger: {
                trigger: '#screen6 [data-anim="cloud"]',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
            },
        });

        // Drop
        gsap.set('#screen6 [data-anim="drop"]', {
            xPercent: -50
        });
        gsap.to('#screen6 [data-anim="drop"]', {
            yPercent: 935,
            scrollTrigger: {
                trigger: '#screen6 [data-anim="drop"]',
                endTrigger: '#screen6',
                start: 'top 0',
                end: 'bottom -40%',
                scrub: 0.1,
            }
        });

        // Refresh ScrollTrigger
        ScrollTrigger.refresh();
    }

    // Fonction pour gérer tous les SplitText
    function handleSplitTexts() {
        // Revert tous les SplitText existants
        splitTextInstances.forEach(split => split.revert());
        splitTextInstances = [];

        // Autres SplitText (textes généraux)
        const elements = document.querySelectorAll('.screen-content p:not([data-anim="text"]), .text-h2');

        elements.forEach((content) => {
            const splitText = new SplitText(content, {
                type: "lines",
                linesClass: "split-line"
            });
            splitTextInstances.push(splitText);

            gsap.set(splitText.lines, {
                opacity: 0,
                y: 40
            });

            gsap.to(splitText.lines, {
                opacity: 1,
                y: 0,
                stagger: 0.05,
                scrollTrigger: {
                    trigger: content,
                    start: 'top 90%',
                    end: 'bottom 20%',
                    scrub: 1
                }
            });
        });

        // Refresh ScrollTrigger après les SplitText
        ScrollTrigger.refresh();
    }

    /** Initialisation Lenis + GSAP ScrollTrigger **/
    const lenis = new Lenis();
    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // Initialisation
    initAnimations();
    handleSplitTexts();

    // Event listener pour le resize avec debounce
    window.addEventListener('resize', debounce(() => {
        handleScreen4Text();
        handleScreen5Text();
        initAnimations();
        handleSplitTexts();
    }, 250));
});